module.exports = __webpack_public_path__ + "523812835e18ce53308fbd32d09e0005.svg";


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/1x1/un.svg
// module id = ./node_modules/flag-icon-css/flags/1x1/un.svg
// module chunks = 0